export { default } from "./PdpCtasV2.vue";
